class MuuriGrid {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }

  event() {
    const muuriGrid = '.' + this.el;
    var grid = new Muuri(muuriGrid, {
      layout: {
        fillGaps: true,
      }
    });
    setTimeout(() => {
      $('.js-loading-anime').fadeOut(300);
      $('.js-muuri-grid, .js-paging').animate({'opacity': '1'});
  }, 200);
  }
}